import {
  StyledDataContextDisabledCaption,
  StyledDataContextInnerBody,
  StyledDataContextInnerCountText,
  StyledDataContextInnerWrapper,
} from 'ui/dataContextMenu/DataContextMenu.styled';

type DataContextSampleFieldProps = {
  sampleValue: string;
};

export const DataContextSampleField = ({ sampleValue }: DataContextSampleFieldProps) => {
  return (
    <StyledDataContextInnerWrapper>
      <StyledDataContextDisabledCaption>Sample Value</StyledDataContextDisabledCaption>
      <StyledDataContextInnerBody>
        <StyledDataContextInnerCountText>{sampleValue}</StyledDataContextInnerCountText>
      </StyledDataContextInnerBody>
    </StyledDataContextInnerWrapper>
  );
};
